import axios from 'axios';
import { jwtTokenPromise } from './jwtTokenPromise';
import { getWindowOptionsProperty } from '../util';

function getForumClientEndpoint() {
    return getWindowOptionsProperty('forum.client.endpoint');
}

const forumClient = axios.create({
    baseURL: getForumClientEndpoint()
});

forumClient.interceptors.response.use(response => response.data);
forumClient.interceptors.request.use(config =>
    jwtTokenPromise().then(token => {
        config.headers['Authorization'] = `Bearer ${token}`;
        config.headers['Content-Type'] = 'application/json';
        return config;
    })
);

export default forumClient;
